import React, { createContext, useState, useEffect } from "react";
import { api } from "../utils/api";

const NoticeContext = createContext();

const NoticesProvider = ({ children }) => {
  const [notices, setNotices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    api
      .get("/api/notices")
      .then((res) => {
        setNotices(res.documents);
        setLoading(false);
      })
      .catch((err) => {
        setError(err.message);
        setLoading(false);
      });
  }, []);

  return (
    <NoticeContext.Provider value={{ notices, loading, error }}>
      {children}
    </NoticeContext.Provider>
  );
};

export { NoticeContext, NoticesProvider };
